import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

export default function Select({
  options,
  label,
  error,
  helperText,
  value,
  onChange,
  size,
  textSx,
}) {
  const selected = options?.find((c) => c.value === value) || null;
  return (
    <Autocomplete
      disablePortal
      options={options}
      value={selected}
      onChange={(e, val) => {
        onChange(val?.value ?? "");
      }}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      filterSelectedOptions
      //   sx={{ width: 300 }}
      renderInput={(params) => (
        <TextField
          {...params}
          sx={textSx}
          size={size}
          label={label}
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
}
